var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-popup flex align-center justify-center"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa","vertical":""}},[_vm._v("正在加载数据...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }